import { useQuery } from '@apollo/client';
import * as Sentry from '@sentry/react';

import GetDegreesById from 'bundles/premium-hub/queries/GetDegreesById.graphql';
import type {
  PremiumHubGetDegreesById_Dedupe1Query as GetDegreesByIdQuery,
  PremiumHubGetDegreesById_Dedupe1QueryVariables as GetDegreesByIdQueryVariables,
} from 'bundles/premium-hub/queries/__generated__/GetDegreesById';

export const useDegreesByIds = (degreeIds: string[], skip?: boolean) => {
  const { data, loading } = useQuery<GetDegreesByIdQuery, GetDegreesByIdQueryVariables>(GetDegreesById, {
    variables: {
      ids: degreeIds,
    },
    skip,
    errorPolicy: 'all',
    onError: (error) =>
      Sentry.captureException(error, {
        extra: {
          message: 'Error fetching premium hub products by IDs',
        },
      }),
  });

  return { data, loading };
};
